module.exports = __webpack_public_path__ + "screen1.webp?de1ad724e7904f60959bbdbcf0a525b4";